module.exports = __webpack_public_path__ + "static/media/UMlogo_pl.db5cf1eb.png";